var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.073,
    height: 18.073,
    viewBox: "0 0 18.073 18.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-circle",
    "data-name": "Icon awesome-exclamation-circle",
    d: "M18.385,9.349A9.036,9.036,0,1,1,9.349.313,9.036,9.036,0,0,1,18.385,9.349ZM9.349,11.171a1.676,1.676,0,1,0,1.676,1.676A1.676,1.676,0,0,0,9.349,11.171ZM7.758,5.146l.27,4.955a.437.437,0,0,0,.437.413h1.769a.437.437,0,0,0,.437-.413l.27-4.955a.437.437,0,0,0-.437-.461H8.194a.437.437,0,0,0-.437.461Z",
    transform: "translate(-0.313 -0.313)",
    fill: "#7e59d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/about-icon.1a3cdde8ee99c353aa6faaa89ee988e4.svg";
export { ForwardRef as ReactComponent };